import { render, staticRenderFns } from "./AfaAnamnesi.vue?vue&type=template&id=934c69b4"
import script from "./AfaAnamnesi.vue?vue&type=script&lang=js"
export * from "./AfaAnamnesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports